import React, { useState, useEffect } from "react";
import axios from "axios";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { toast } from "react-toastify";
import { Spin } from "antd";
import { useNavigate } from "react-router";
const CreateContact = () => {
  const [formData, setFormData] = useState({
    page_title: "",
    summery: "",
    email: [""],
    phone: [""],
    location: "",
    address: "",
    map_embed_url: "",
    logo: "",
    facebook_link: "",
    instagram_link: "",
    linkedin_link: "",
    x_link: "",
    logo_file: null,
  });

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const [summaryLength, setSummaryLength] = useState(0);
  const navigate = useNavigate();
  const modules = {
    toolbar: [
    ['bold', 'italic', 'underline', 'strike'],
    [{ 'header': [1, 2, 3, false] }],
    [{ 'align': [] }],
    [{ 'list': 'ordered' }, { 'list': 'bullet' }],
    [{ 'indent': '-1' }, { 'indent': '+1' }],
    ['link'],
    ['clean']
  ],
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API_URL}/api/contact/contact`
        );
        if (res.data) {
          // Ensure email and phone are always arrays
          const { email, phone } = res.data;

          setFormData({
            page_title: res.data.page_title || "",
            summery: res.data.summery || "",
            email: JSON.parse(email),
            phone: JSON.parse(phone),
            location: res.data.location || "",
            address: res.data.address || "",
            map_embed_url: res.data.map_embed_url || "",
            logo: res.data.logo || "",
            facebook_link: res.data.facebook_link || "",
            instagram_link: res.data.instagram_link || "",
            linkedin_link: res.data.linkedin_link || "",
            x_link: res.data.x_link || "",
          });

          // Initialize summary length
          if (res.data.summery) {
            const plainText = res.data.summery.replace(/<[^>]*>/g, "");
            setSummaryLength(plainText.length);
          }
        }
      } catch (err) {
        console.error("Fetch Error:", err);
        setError("Failed to load contact information");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const handleChange = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleListChange = (type, index, value) => {
    const updated = [...formData[type]];
    updated[index] = value;
    setFormData((prev) => ({ ...prev, [type]: updated }));
  };

  const addField = (type) => {
    setFormData((prev) => ({ ...prev, [type]: [...prev[type], ""] }));
  };

  const removeField = (type, index) => {
    const updated = [...formData[type]];
    updated.splice(index, 1);
    setFormData((prev) => ({ ...prev, [type]: updated }));
  };

  const handleSummaryChange = (content) => {
    // Calculate plain text length without HTML tags
    const plainText = content.replace(/<[^>]*>/g, "");
    const newLength = plainText.length;

    // Only update if within limit or if deleting characters
    if (newLength <= 250 || newLength < summaryLength) {
      setFormData((prev) => ({ ...prev, summery: content }));
      setSummaryLength(newLength);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate summary length
    if (summaryLength > 250) {
      setError("Summary cannot exceed 250 characters");
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const formDataToSend = new FormData();

      // Append all fields
      formDataToSend.append("page_title", formData.page_title);
      formDataToSend.append("summery", formData.summery);
      formDataToSend.append("email", JSON.stringify(formData.email));
      formDataToSend.append("phone", JSON.stringify(formData.phone));
      formDataToSend.append("location", formData.location);
      formDataToSend.append("address", formData.address);
      formDataToSend.append("map_embed_url", formData.map_embed_url);
      formDataToSend.append("existing_logo", formData.logo);
      formDataToSend.append("facebook_link", formData.facebook_link);
      formDataToSend.append("instagram_link", formData.instagram_link);
      formDataToSend.append("linkedin_link", formData.linkedin_link);
      formDataToSend.append("x_link", formData.x_link);

      // Append logo file if selected
      if (formData.logo_file) {
        formDataToSend.append("logo", formData.logo_file);
      }

      const response = await axios.put(
        `${process.env.REACT_APP_API_URL}/api/contact/contentInfo`,
        formDataToSend,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      // Update logo URL if new one was uploaded
      if (response.data.logo) {
        setFormData((prev) => ({ ...prev, logo: response.data.logo }));
      }

      setSuccess(true);
      toast.success("success fully updated")
      setTimeout(() => setSuccess(false), 3000);
    } catch (err) {
      toast.error("update failed" + err)
      if (err.response?.status === 401 || err.status === 401) {
        // If unauthorized, redirect to login
        navigate("/login");
      }
      setError(err.response?.data?.error || "Update failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

   if (loading) {
    return (
      <div className="flex justify-center items-center min-h-[60vh]">
        <Spin size="medium" />
      </div>
    );
  }

  return (
    <div className="max-w-5xl mx-auto p-6 bg-white rounded-xl shadow-lg mt-6">
      <div className="mb-8 border-b pb-4">
        <h2 className="text-3xl font-bold text-gray-800">
          {formData.page_title ? "Edit Contact Page" : "Create Contact Page"}
        </h2>
        <p className="text-gray-600">
          Manage all contact information and social links
        </p>
      </div>

      {error && (
        <div className="mb-6 p-4 bg-red-50 text-red-700 rounded-lg flex items-center">
          <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 20 20">
            <path
              fillRule="evenodd"
              d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
              clipRule="evenodd"
            />
          </svg>
          {error}
        </div>
      )}

      {success && (
        <div className="mb-6 p-4 bg-green-50 text-green-700 rounded-lg flex items-center">
          <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 20 20">
            <path
              fillRule="evenodd"
              d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
              clipRule="evenodd"
            />
          </svg>
          Contact information updated successfully!
        </div>
      )}

      <form onSubmit={handleSubmit} className="space-y-8">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* Left Column */}
          <div className="space-y-6">
            {/* Page Title */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Page Title *
              </label>
              <input
                name="page_title"
                value={formData.page_title}
                onChange={handleChange}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-transparent"
              />
            </div>

            {/* Logo Upload */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Logo
              </label>
              <div className="flex items-center space-x-4">
                <div className="relative flex-1">
                  <input
                    type="file"
                    accept="image/*"
                    onChange={(e) => {
                      if (e.target.files[0]) {
                        setFormData((prev) => ({
                          ...prev,
                          logo_file: e.target.files[0],
                        }));
                      }
                    }}
                    className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
                    id="logo-upload"
                  />
                  <label
                    htmlFor="logo-upload"
                    className="block w-full px-4 py-3 border border-gray-300 rounded-lg cursor-pointer bg-white"
                  >
                    <span className="text-gray-500">
                      {formData.logo_file
                        ? formData.logo_file.name
                        : "Choose file..."}
                    </span>
                  </label>
                </div>
                {formData.logo && (
                  <div className="flex-shrink-0">
                    <p className="text-sm text-gray-500 mb-1">Current Logo:</p>
                    <img
                      src={`${process.env.REACT_APP_API_URL}${formData.logo}`}
                      alt="Logo"
                      className="h-12 w-12 object-contain border rounded"
                    />
                  </div>
                )}
              </div>
              <input
                type="hidden"
                name="existing_logo"
                value={formData.logo}
              />
              <p className="mt-1 text-xs text-gray-500">
                Recommended: Square PNG (max 500KB)
              </p>
            </div>

            {/* Summary */}
            <div>
              <div className="flex justify-between items-center mb-2">
                <label className="block text-sm font-medium text-gray-700">
                  Summary
                </label>
                <span
                  className={`text-xs ${
                    summaryLength > 250
                      ? "text-red-500"
                      : summaryLength > 200
                      ? "text-yellow-500"
                      : "text-gray-500"
                  }`}
                >
                  {summaryLength} / 250 characters
                </span>
              </div>
              <div className="border border-gray-300 rounded-lg overflow-hidden">
                <ReactQuill
                  theme="snow"
                  value={formData.summery}
                  onChange={handleSummaryChange}
                  modules={modules}
                  className="bg-white h-52"
                  placeholder="write this"
                />
              </div>
              {summaryLength > 250 && (
                <p className="mt-1 text-xs text-red-500">
                  Summary exceeds maximum length by {summaryLength - 250}{" "}
                  characters
                </p>
              )}
            </div>

            {/* Location */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Location
              </label>
              <input
                name="location"
                value={formData.location}
                onChange={handleChange}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-transparent"
                placeholder="e.g., Bishoftu, Oromia, Ethiopia"
              />
            </div>

            {/* Address */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Address
              </label>
              <textarea
                name="address"
                value={formData.address}
                onChange={handleChange}
                rows="3"
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-transparent"
              />
            </div>
          </div>

          {/* Right Column */}
          <div className="space-y-6">
            {/* Email List */}
            <div className="bg-gray-50 p-5 rounded-xl">
              <div className="flex justify-between items-center mb-3">
                <label className="block text-sm font-medium text-gray-700">
                  Email Addresses
                </label>
                <button
                  type="button"
                  onClick={() => addField("email")}
                  className="text-blue-600 hover:text-blue-800 text-sm font-medium flex items-center"
                >
                  <svg
                    className="w-4 h-4 mr-1"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                    ></path>
                  </svg>
                  Add Email
                </button>
              </div>

              {formData.email.map((email, i) => (
                <div key={i} className="flex gap-2 mb-3">
                  <input
                    type="email"
                    value={email}
                    onChange={(e) =>
                      handleListChange("email", i, e.target.value)
                    }
                    className="flex-1 px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-transparent"
                    placeholder="contact@example.com"
                  />
                  {formData.email.length > 1 && (
                    <button
                      type="button"
                      onClick={() => removeField("email", i)}
                      className="bg-gray-200 hover:bg-gray-300 text-gray-700 px-3 rounded-lg"
                    >
                      ✕
                    </button>
                  )}
                </div>
              ))}
            </div>

            {/* Phone List */}
            <div className="bg-gray-50 p-5 rounded-xl">
              <div className="flex justify-between items-center mb-3">
                <label className="block text-sm font-medium text-gray-700">
                  Phone Numbers
                </label>
                <button
                  type="button"
                  onClick={() => addField("phone")}
                  className="text-blue-600 hover:text-blue-800 text-sm font-medium flex items-center"
                >
                  <svg
                    className="w-4 h-4 mr-1"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                    ></path>
                  </svg>
                  Add Phone
                </button>
              </div>

              {formData.phone.map((phone, i) => (
                <div key={i} className="flex gap-2 mb-3">
                  <input
                    type="text"
                    value={phone}
                    onChange={(e) =>
                      handleListChange("phone", i, e.target.value)
                    }
                    className="flex-1 px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-transparent"
                    placeholder="+251 900000000"
                  />
                  {formData.phone.length > 1 && (
                    <button
                      type="button"
                      onClick={() => removeField("phone", i)}
                      className="bg-gray-200 hover:bg-gray-300 text-gray-700 px-3 rounded-lg"
                    >
                      ✕
                    </button>
                  )}
                </div>
              ))}
            </div>

            {/* Map Embed */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Google Maps Embed URL
              </label>
              <input
                name="map_embed_url"
                value={formData.map_embed_url}
                onChange={handleChange}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-transparent"
                placeholder="https://maps.google.com/embed?q=..."
              />
              {formData.map_embed_url && (
                <div className="mt-3 bg-gray-100 p-2 rounded-lg">
                  <p className="text-sm text-gray-500 mb-2">Map Preview:</p>
                  <iframe
                    title="map-preview"
                    src={formData.map_embed_url}
                    className="w-full h-48 border-0 rounded-lg"
                    loading="lazy"
                  ></iframe>
                </div>
              )}
            </div>

            {/* Social Media Links */}
            <div className="bg-blue-50 p-5 rounded-xl">
              <h3 className="font-medium text-gray-700 mb-3">
                Social Media Links
              </h3>

              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-xs font-medium text-gray-500 mb-1">
                    Facebook
                  </label>
                  <div className="flex">
                    <span className="inline-flex items-center px-3 rounded-l-md border border-r-0 border-gray-300 bg-gray-50 text-gray-500 text-sm">
                      fb.com/
                    </span>
                    <input
                      name="facebook_link"
                      value={formData.facebook_link}
                      onChange={handleChange}
                      className="flex-1 min-w-0 block w-full px-3 py-2 rounded-r-md border border-gray-300 focus:ring-blue-500 focus:border-blue-500"
                      placeholder="yourpage"
                    />
                  </div>
                </div>

                <div>
                  <label className="block text-xs font-medium text-gray-500 mb-1">
                    Instagram
                  </label>
                  <div className="flex">
                    <span className="inline-flex items-center px-3 rounded-l-md border border-r-0 border-gray-300 bg-gray-50 text-gray-500 text-sm">
                      instagram.com/
                    </span>
                    <input
                      name="instagram_link"
                      value={formData.instagram_link}
                      onChange={handleChange}
                      className="flex-1 min-w-0 block w-full px-3 py-2 rounded-r-md border border-gray-300 focus:ring-blue-500 focus:border-blue-500"
                      placeholder="yourpage"
                    />
                  </div>
                </div>

                <div>
                  <label className="block text-xs font-medium text-gray-500 mb-1">
                    LinkedIn
                  </label>
                  <div className="flex">
                    <span className="inline-flex items-center px-3 rounded-l-md border border-r-0 border-gray-300 bg-gray-50 text-gray-500 text-sm">
                      linkedin.com/
                    </span>
                    <input
                      name="linkedin_link"
                      value={formData.linkedin_link}
                      onChange={handleChange}
                      className="flex-1 min-w-0 block w-full px-3 py-2 rounded-r-md border border-gray-300 focus:ring-blue-500 focus:border-blue-500"
                      placeholder="company/yourpage"
                    />
                  </div>
                </div>

                <div>
                  <label className="block text-xs font-medium text-gray-500 mb-1">
                    X (Twitter)
                  </label>
                  <div className="flex">
                    <span className="inline-flex items-center px-3 rounded-l-md border border-r-0 border-gray-300 bg-gray-50 text-gray-500 text-sm">
                      twitter.com/
                    </span>
                    <input
                      name="x_link"
                      value={formData.x_link}
                      onChange={handleChange}
                      className="flex-1 min-w-0 block w-full px-3 py-2 rounded-r-md border border-gray-300 focus:ring-blue-500 focus:border-blue-500"
                      placeholder="yourpage"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="pt-6 border-t flex justify-end">
          <button
            type="submit"
            disabled={loading || summaryLength > 250}
            className={`${
              loading || summaryLength > 250
                ? "bg-gray-400 cursor-not-allowed"
                : "bg-gradient-to-r from-blue-600 to-indigo-700 hover:from-blue-700 hover:to-indigo-800"
            } text-white font-medium py-3 px-8 rounded-lg shadow-md transition-all duration-300 flex items-center`}
          >
            {loading ? (
              <>
                <svg
                  className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <circle
                    className="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="4"
                  ></circle>
                  <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                  ></path>
                </svg>
                Saving...
              </>
            ) : (
              "Save Contact Information"
            )}
          </button>
        </div>
      </form>
    </div>
  );
};

export default CreateContact;
